import { ReactElement } from 'react'
import { connect } from 'react-redux'
import { find } from 'lodash'

import Operations from '../../../../../operations'
import Selectors from '../../../../../selectors'
import {
  ConsentFormTemplate,
  CreateConsentFormsJSON,
  RouterProps
} from '@lmc/common/types'
import { getResidentConsentFormsTemplates } from './components/ConsentFormModal/utils'

import { withRouter } from '../../../../../withRouter'

import { Resident } from '@lmc/ts-common'
import useFeatureFlags from 'hooks/useFeatureFlags'
import {
  ResidentConsentFormsScreenNew,
  ResidentConsentFormsScreenProps
} from './ResidentConsentFormsScreenNew'
import { ResidentConsentFormsScreenLegacy } from './ResidentConsentFormsScreenLegacy'

type ResidentConsentFormsScreenWrapperProps = ResidentConsentFormsScreenProps & {
  router: RouterProps
}

export const ResidentConsentFormsScreen = (
  props: ResidentConsentFormsScreenWrapperProps
): ReactElement => {
  const featureFlags = useFeatureFlags({ flagNames: ['informed_consent'] }).data
  const isInformedConsentEnabled =
    featureFlags['informed_consent']?.enabled || false

  if (isInformedConsentEnabled) {
    return <ResidentConsentFormsScreenNew {...props} />
  }
  return <ResidentConsentFormsScreenLegacy {...props} />
}

const mapStateToProps = (
  state: {
    data: {
      templates: ConsentFormTemplate[]
      residents: Resident[]
    }
    global: {
      home: {
        carePlans: boolean
        preferredPeopleNominative?: string
      }
    }
  },
  props: any
) => {
  const consentForms = Selectors.getResidentConsentForms(state)
  return {
    consentForms: Selectors.getResidentConsentForms(state),
    resident: find(state.data.residents, { id: props.router.params.id }),
    // @ts-ignore
    signatureItem: find(state.data['log-category-items'], {
      itemId: 'signature'
    }),
    templates: getResidentConsentFormsTemplates(
      // @ts-ignore
      state?.data['consent-templates'],
      consentForms
    ),
    hasCarePlans: state.global.home.carePlans,
    preferredPeopleNominative: state.global.home.preferredPeopleNominative
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  archiveConsentForm: (consentFormID: string, successMsg: string) => {
    dispatch(
      Operations.updateListItem({
        listId: 'consent-forms',
        itemId: consentFormID,
        json: { isArchived: true },
        successMsg
      })
    )
  },
  createConsentForms: (consentForms: CreateConsentFormsJSON) =>
    dispatch(
      Operations.createListItem({
        listId: 'consent-forms',
        itemId: 'sign',
        json: consentForms
      })
    ),
  fetchResidentConsentForms: (resident: any) => {
    dispatch(Operations.loadList('consent-forms', { resident }))
    dispatch(Operations.loadList('consent-templates'))
  }
})

export default withRouter(
  connect<any, any, any>(
    // @ts-ignore
    mapStateToProps,
    mapDispatchToProps
  )(ResidentConsentFormsScreen)
)
